import React from "react";

const ObrigacoesSuspensasCard = ({ obrigacoesSuspensas }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>{obrigacoesSuspensas?.titulo}</b>
      </div>
      <div className="card-body">
        <table className="table table-striped table-bordered" width="100%">
          <thead>
            <tr>
              <th>
                <center>
                  <b>Descrição da Obrigação</b>
                </center>
              </th>
              <th>
                <center>
                  <b>Motivo Suspensão</b>
                </center>
              </th>
            </tr>
          </thead>
          <tbody>
            {obrigacoesSuspensas?.obrigacoes?.map((obrigacao) => (
              <tr>
                <td>
                  <center>
                    {obrigacao.flagTitulo === "N" ? (
                      obrigacao.descricaoObrigacao
                    ) : (
                      <strong className="text-header">{obrigacao.descricaoObrigacao}</strong>
                    )}
                  </center>
                </td>
                <td>
                  <center>
                    {obrigacao.flagTitulo === "N" ? (
                      obrigacao.motivoSuspensao
                    ) : (
                      <strong className="header">{obrigacao.motivoSuspensao}</strong>
                    )}
                  </center>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default ObrigacoesSuspensasCard;
